import Vue from 'vue'
import App from './App.vue'
// 关闭vue的生产提示
Vue.config.productionTip = false
import '../src/assets/css/all.css'

import util from '../src/utils/util.js';
import modal from '../src/utils/modal';
/**
 * 引入VUEX
 * 
*/
import store from './store'





/**
 * 1.引入路由
 * 2.引入路由权限
 */
import router from './router/index.js'
import './router/permission.js'







/**
 * 1.引入element ui
*/
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
ElementUI.Dialog.props.lockScroll.default= false;




/**
 * 引入vue的滚动 v-scroll-to
*/
import {scroller} from '@/scroll/scrollTo.js'

//  引入Echarts
import * as echarts from 'echarts'


// 自定义组件  --- 顶部登录
import Toplogin from '@/components/toplogin' ;
Vue.component('Toplogin',Toplogin)

// 自定义组件 --- 上传
import Upload from '@/components/upload';
Vue.component('Upload',Upload)

import uploadImg from '@/components/uploadimg';
Vue.component('uploadImg',uploadImg)

import File from "@/components/file";
Vue.component('File',File)

// 自定义组件 --- 分页
import Pagination from "@/components/Pagination";
Vue.component('Pagination', Pagination);


// 自定义组件1 --- 分页1
import Paginations from "@/components/Pagination/index2.vue";
Vue.component('Paginations', Paginations);



// 自定义指令  --- 懒加载
import dataSrc from '../src/utils/v-datasrc.js';
Vue.directive('datasrc', dataSrc);

// 注册虚拟滚动
import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

Vue.use(VueVirtualScroller);



// 全局挂载方法
Vue.prototype.$scrollTo = scroller()
Vue.prototype.$echarts = echarts
Vue.prototype.$util = util
Vue.prototype.$modal = modal
new Vue({
  el:'#app',
  render: h => h(App),
  router,
  store
})
